import { z } from "zod";

// t("EN")
// t("AR")
// t("FR")
export const languagesEnum = z.enum(["EN", "AR", "FR"]);

export type Language = z.infer<typeof languagesEnum>;
